import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=bbdfb8f2&scoped=true"
import script from "./CategoryEdit.vue?vue&type=script&lang=js"
export * from "./CategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./CategoryEdit.vue?vue&type=style&index=0&id=bbdfb8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdfb8f2",
  null
  
)

export default component.exports